import { MlBannerHeadingCta, MlBannerHeadingCtaProps } from './ml-banner-heading-cta'
import { MLBannerImageHeadingCta, MLBannerImageHeadingCtaProps } from './ml-banner-image-heading-cta'
import { MlBannerLogo, MlBannerLogoProps } from './ml-banner-logo'
import { MlBannerHomeSearch, MlBannerHomeSearchProps } from './ml-banner-home-search'
import { DropdownOption } from '../../atoms'

type MlSiteBannerVariant = 'logo' | 'heading-cta' | 'side-img-heading-cta' | 'home-search'

export interface MlSiteBannerProps
  extends MlBannerLogoProps,
    MLBannerImageHeadingCtaProps,
    MlBannerHeadingCtaProps,
    MlBannerHomeSearchProps {
  variant: MlSiteBannerVariant
  locationOptions?: DropdownOption[]
}

export type { MlBannerHomeSearchSolution } from './ml-banner-home-search'

export const MlSiteBanner = ({ variant = 'logo', locationOptions, ...mlSiteBannerProps }: MlSiteBannerProps) => {
  if (variant === 'logo') return <MlBannerLogo {...mlSiteBannerProps} />
  if (variant === 'heading-cta') return <MlBannerHeadingCta {...mlSiteBannerProps} />
  if (variant === 'side-img-heading-cta') return <MLBannerImageHeadingCta {...mlSiteBannerProps} />
  if (variant === 'home-search') return <MlBannerHomeSearch {...mlSiteBannerProps} locationOptions={locationOptions} />
  return null
}
